export class CleanUpPropertyStateError extends Error {

}
